module.exports = __webpack_public_path__ + "media/images/grounded-logo-grey-a235aa9af95d29eb613b467b00ef3839.svg";